import React, { useContext, useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import useDelete from "../Hooks/useDelete";
import { missionsURL, reportsURL } from "../Hooks/URL";
import { useParams } from "react-router-dom";
import { userContext } from "../Contexts/userContext";
import useSave from "../Hooks/useSave";
import AgeGroupDetails from "../Templates/Home/Categories/AgeGroupDetails/AgeGroupDetails";
import useFetchWhen from "../Hooks/useFetchWhen";
import Missions from "../Templates/Home/Missions/MissionDetails/MissionDetails";
import MissionDetails from "../Templates/Home/Missions/MissionDetails/MissionDetails";
import useEdit from "../Hooks/useEdit";

function MissionDetailsPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id, categoryId } = useParams();

  const url = `${missionsURL}/${id}`;
  const teamsUrl = `${missionsURL}/${id}/teams`;
  const judgesUrl = `${missionsURL}/${id}/judges`;

  const [mission, setMission] = useState({});
  const [judgingStatus, setJudgingStatus] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState("");
  const [showRanking, setShowRanking] = useState(true);
  const [forceSubmission, setForceSubmission] = useState(true);
  const [teams, setTeams] = useState([]);
  const [judges, setJudges] = useState([]);
  const { data, loading, error } = useFetch(url);
  const {
    data: teamsData,
    loading: teamsLoading,
    error: teamsError,
  } = useFetch(teamsUrl);
  const {
    data: judgesData,
    loading: judgesLoading,
    error: judgesError,
  } = useFetch(judgesUrl);

  useEffect(() => {
    if (!loading && !error && data) {
      setMission(data?.data);
      setJudgingStatus(data?.data?.judgingStatus);
      setSubmissionStatus(data?.data?.submissionStatus);
      setShowRanking(data?.data?.showRanking);
      setForceSubmission(data?.data?.forceSubmission);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!teamsLoading && !teamsError && teamsData) {
      setTeams(teamsData?.data);
    }
  }, [teamsData, teamsLoading, teamsError]);

  useEffect(() => {
    if (!judgesError && !judgesLoading && judgesData) {
      setJudges(judgesData?.data);
    }
  }, [judgesData, judgesLoading, judgesError]);

  const [goEdit, setGoEdit] = useState(false);
  const { saveState, loading: addLoading } = useEdit({
    url: `${url}/settings`,
    goEdit,
    setGoEdit,
    newObject:
      showRanking != mission?.showRanking
        ? {
            showRanking: showRanking,
          }
        : forceSubmission != mission?.forceSubmission
        ? {
            forceSubmission: forceSubmission,
          }
        : submissionStatus != mission?.submissionStatus
        ? {
            newSubmissionStatus: submissionStatus,
          }
        : judgingStatus != mission?.judgingStatus
        ? {
            newJudgingStatus: judgingStatus,
          }
        : {},
    refreshAfter: true,
  });

  const [goMission, setGoMission] = useState(false);
  const { deleteResMission } = useDelete(
    `${missionsURL}/${id}`,
    goMission,
    `categories/${mission?.category?.id}/ageGroups/${mission?.category?.ageGroup?.id}`
  );

  const [attributes, setAttributes] = useState({});
  const {
    data: attributesData,
    loading: attributesLoading,
    error: attributesError,
  } = useFetchWhen(
    `${missionsURL}/${mission?.id}/report`,
    mission?.id ?? false,
    false
  );

  useEffect(() => {
    if (!attributesLoading && !attributesError && attributesData) {
      setAttributes(attributesData?.data);
    }
  }, [attributesData, attributesLoading, attributesError]);

  const [OpenGenetare, setOpenGenerate] = useState(false);
  const [Open, setOpen] = useState(false);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(
    `${missionsURL}/${mission?.id}/report`,
    go,
    null,
    null,
    null,
    {},
    true
  );

  return (
    <MissionDetails
      mission={mission}
      role={contextData?.role}
      url={url}
      loading={loading}
      teams={teams}
      judges={judges}
      judgesLoading={judgesLoading}
      setJudgingStatus={setJudgingStatus}
      setGoSave={setGoEdit}
      setGoMission={setGoMission}
      showRanking={showRanking}
      setShowRanking={setShowRanking}
      forceSubmission={forceSubmission}
      setForceSubmission={setForceSubmission}
      submissionStatus={submissionStatus}
      setSubmissionStatus={setSubmissionStatus}
      addLoading={addLoading}
      attributes={attributes}
      attributesLoading={attributesLoading}
      OpenGenetare={OpenGenetare}
      setOpenGenerate={setOpenGenerate}
      Open={Open}
      setOpen={setOpen}
      setGo={setGo}
    />
  );
}

export default MissionDetailsPage;
